(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/race/normalize-race-model.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/race/normalize-race-model.js');
'use strict';

const {
  format,
  parseISO
} = dateFns;
const {
  gameTypes,
  gameTypeToSubProductId
} = svs.racing.common.constants;
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const normalizeRaceModel = _ref => {
  var _meeting$track;
  let {
    drawNumber,
    productId,
    data
  } = _ref;
  const {
    raceNumber,
    draws,
    startTimeTentative,
    meeting,
    participants,
    numberOfParticipants,
    raceName
  } = data;
  if (!Array.isArray(draws) || !Array.isArray(participants) || !numberOfParticipants || !meeting) {
    throw new Error('Failed to normalize race: Missing data about draws, participants and meeting');
  }
  const currentDraw = draws.find(item => item.drawNumber === drawNumber);
  if (!currentDraw) {
    throw new Error('Failed to normalize race: Can\'t find draw');
  }
  const silksFormattedDate = meeting !== null && meeting !== void 0 && meeting.date ? format(parseISO(meeting.date), 'yyyyMMdd') : undefined;
  const _mapParticipant = item => ({
    number: item.participantNumber,
    horseName: item.horseName,
    driverName: item.driverName || null,
    silkImageOptions: item.silks ? getImageOptions(item.silks, silksFormattedDate, ImageTypes.CouponSilk) : null
  });
  const subProductId = String(currentDraw.userProduct).toUpperCase();
  const isHighFive = subProductId === String(gameTypeToSubProductId[gameTypes.TOPP5]).toUpperCase();
  return {
    drawNumber,
    productName: currentDraw.productName,
    subProductId,
    isHighFive,
    closeTime: startTimeTentative,
    trackName: meeting === null || meeting === void 0 || (_meeting$track = meeting.track) === null || _meeting$track === void 0 ? void 0 : _meeting$track.trackName,
    raceNumber,
    participants: participants.map(_mapParticipant),
    productId,
    numberOfParticipants,
    raceName
  };
};
setGlobal('svs.components.sport.raceHandler.race.normalizeRaceModel', normalizeRaceModel);

 })(window);